<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;height: 12rem;background: #f3f3f3;font-size: 18px;">
			<div style="text-align: center;padding-top: 8px;">
				<img src="../../../../../../assets/image/authen.png" />
			</div>
			<div style="text-align: center;">
				身份认证
			</div>
		</div>
		<div style="width: 100%;padding-top: 32px;">
			<Row type="flex" justify="center" align="center" class="RowClass">
				<Col span="8" class="tdClass">
					姓　名：
				</Col>
				<Col span="16">
					<Input v-model="person.pname" suffix="ios-contact" style="width: 80px" />
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" class="RowClass">
				<Col span="8" class="tdClass">
					身份证：
				</Col>
				<Col span="16"> 
					<Input v-model="person.pno" :type="person.pno.length>=17?'text':'number'" @on-keyup="pnoValide()" :maxlength="18" suffix="ios-card" placeholder="请输入18位身份证号码" style="width: 163px" />
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" class="RowClass">
				<Col span="8" class="tdClass">
					手　机：
				</Col>
				<Col span="16">
					<Input v-model="person.pphone" @keyup.native="person.pphone=person.pphone.length>11?person.pphone.slice(0,11):person.pphone" type="number" suffix="ios-phone-portrait" placeholder="请输入您的手机号" style="width: 138px" />
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" class="RowClass">
				<Col span="8">
				</Col>
				<Col span="8">
					<Button @click="Binding" type="info" long>绑定</Button>
				</Col>
				<Col span="8">
				</Col>
			</Row>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				person:{
					pname:'',
					pno:'',
					psex:'',
					pbirthday:'',
					pphone:''
				}
			}
		},
		created:function(){
			if(sessionStorage.person==undefined){
				this.$router.push('/404');
				return ;
			}
			let person=JSON.parse(sessionStorage.person); 
			for(let key in person){
				this.person[key]=person[key];
			}
		},
		methods:{
			pnoValide(){
				let value=this.person.pno;
				let data=value.slice(value.length-1,value.length);
				if(value.length==18){
					if(data=='x'){
						this.person.pno=value.slice(0,value.length-1)+'X';
					}else if(data!='X'&&(data.charCodeAt()<48||data.charCodeAt()>57)){
						this.person.pno=value.slice(0,value.length-1)
					}
					return ;
				}
			},
			Binding(){
				let pno=this.person.pno;
				if(this.person.pname.length<2){
					this.$Message.warning({content:'姓名填写格式不正确',duration:3});
					return ;
				}else if(pno.length!=18){
					this.$Message.warning({content:'身份证长度为18位,请检查!',duration:3});
					return ;
				}else if(this.person.pphone.length!=11){
					this.$Message.warning({content:'手机号码长度为11位,请检查!',duration:3});
					return ;
				} 
				this.person.psex=parseInt(pno.slice(pno.length-2,pno.length-1))%2==1?'0':'1';
				this.person.pbirthday=pno.slice(6,14);
				this.$http.post('person/AddPerson',this.person).then((res)=> {
					if(res.code=='200'){
						for(let key in res.data){
							this.person[key]=res.data[key];
						}
						sessionStorage.person=JSON.stringify(this.person);
						this.$Message.success({content:'绑定成功!3秒后自动跳转页面',duration:3});
						let router=this.$router;
						let returnName=this.$route.params.returnName;
						setTimeout(function(){
							router.push({name:returnName});
						},3000);
						return ;
					}
					this.$Message.error(res.msg);
				});
				
			}
			
		},
		watch:{
		}
		
	}
</script>
<style>
	.tdClass{
		text-align: right;
		line-height: 32px;
	}
	
	.RowClass{
		margin: 18px;
	}
</style>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Testing/Binding/index.vue